export var dataHooks = {
  notificationText: 'notification-text',
  notificationBannerIcon: 'notification-banner-icon',
  notificationLink: 'notification-link'
};